import React from 'react'
import { Instagram } from '@mui/icons-material'
import { LinkedIn } from '@mui/icons-material'
import { Twitter } from '@mui/icons-material'
import { Facebook } from '@mui/icons-material'
import '../styles/Footer.css'
const Footer = () => {
  return (
    <div className='footer'>
      <div className='socialMedia'>
      <Instagram/>
      <LinkedIn/>
      <Twitter/>
      <Facebook/>
        <p>&copy;  Mayank 2023 </p>
        
      </div>
    </div>
  )
}

export default Footer
